import { styled } from '@mui/material';
import { GivelifyIcon } from '../../icon';
import { DesignTokens } from '../../specify';
import { AlignDirection } from '../types';

export const TBHead = styled('th', {
    shouldForwardProp: (prop) => prop !== 'canSort' && prop !== 'headerAlign',
})<{ canSort: boolean; headerAlign?: AlignDirection }>(
    ({ canSort, headerAlign }) => ({
        boxSizing: 'border-box',
        textAlign:
            headerAlign === 'left'
                ? 'left'
                : headerAlign === 'center'
                ? 'center'
                : 'right',
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 20,
        paddingBottom: 20,
        color: `${DesignTokens.color.grey600} !important`,
        backgroundColor: DesignTokens.color.textWhite,
        ...(canSort
            ? {
                  '&:hover': {
                      cursor: 'pointer',
                      '& $TBHeadIconSort': {
                          display: 'initial',
                      },
                  },
              }
            : {}),
    }),
);

export const TBHeadIconSort = styled(GivelifyIcon, {
    shouldForwardProp: (prop) => prop !== 'sortedByColumn',
})<{ sortedByColumn?: boolean }>(({ sortedByColumn }) => ({
    display: sortedByColumn ? 'initial' : 'none',
}));
